module.exports = __webpack_public_path__ + "img/dumpling_dip.1a1e2a95.jpg";